import moment from "moment";

import countiesList from "../constants/states_counties_cities.json";
import axios from "axios";

/**
 *
 * @param {Ref} element a ref of the element to scroll to the top off
 */
const scrollToTop = (element) => {
  element.current.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

/**
 *
 * @param {number} days the number days to calculate for after today (including today)
 * @returns an array with key display in the form (Mar 30, Monday) and iso date of as value
 *
 **/
const getDatesFromToday = (days = 30, weekday = "short") => {
  const dates = [];
  for (let i = 0; i < days; i++) {
    dates.push({
      display: new Date(
        new Date().setDate(new Date().getDate() + i),
      ).toDateString("en", {
        month: "short",
        weekday,
        day: "numeric",
      }),

      value: new Date().setDate(new Date().getDate() + i),
    });
  }

  return dates;
};

const getOpenHouseDateFormat = (val) => {
  // console.log(val)
  const day = val.substr(0, 4);
  const time = val.substr(5);
  const options = { weekday: "short" };
  const event = new Date(Date(day)).toLocaleDateString("en-GH", options);
  return `${event.toUpperCase()}, ${time.toUpperCase()}`;
};

const getOpenHouseTime = (start, end) => {
  // const startDate = new Date(date);
  // const year = new Date().getFullYear();
  // const start = moment(`${startDate?.substr(0, 4)}/${year}`).format("ddd");
  // return `OPEN ${start}, ${time?.substr(4)}`.toUpperCase();
  const startMoment = moment(start);
  const endMoment = moment(end);

  if (!startMoment.isValid() || !endMoment.isValid()) {
    return "";
  }

  const dayOfWeek = startMoment.format("ddd");
  const startTime = startMoment.format("h:mmA");
  const endTime = endMoment.format("h:mmA");
  return `OPEN ${dayOfWeek}, ${startTime} TO ${endTime}`.toUpperCase();
};

const crmlsOpenHouseTime = (start, end) => {
  const st = start?.slice(0, -1);
  const startDate = st?.join("-");

  const ed = end?.slice(0, -1);
  const endDate = ed?.join("-");

  const openDate = moment(`${startDate}`).format("ddd");
  const openTimeFrom = new Date(startDate)?.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  });
  const openTimeTo = new Date(endDate)?.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "numeric",
  });

  return `OPEN ${openDate}, ${openTimeFrom} - ${openTimeTo}`.toUpperCase();
};

//get name from string with underscore and capitalize first letter
const removeUnderandCapitalize = (string) => {
  return string
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 *
 * @param {*} number number to format
 * @param {*} decimals number of decimals to show, default 2
 * @returns formatted number
 */
const formatNumber = (number, decimals = 2) => {
  if (number) {
    return Number(number).toLocaleString("en-US", {
      minimumFractionDigits: decimals,
    });
  } else return "0";
};

/**
 *
 * @param {*} url non formatted url
 * @returns url with embedd
 */
function getYoutubeEmbedLink(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
}

/**
 *
 * @param {[]} subs
 * @returns
 */

const getSubscriptionStatus = (subs) => {
  const status = {
    bpoFarm: false,
    premierAgentWebsite: false,
    liveLeads: false,
    dealAnalyzer: false,
  };

  if (subs.length === 0) {
    return status;
  }
  if (subs.some((item) => item.package === "bpo-farm")) {
    return {
      bpoFarm: true,
      premierAgentWebsite: true,
      liveLeads: true,
      dealAnalyzer: true,
    };
  }
  if (subs.some((item) => item.package === "combo-package")) {
    status.dealAnalyzer = true;
    status.premierAgentWebsite = true;
    status.liveLeads = true;
  }
  if (subs.some((item) => item.package === "premier-agent-website")) {
    status.premierAgentWebsite = true;
    status.liveLeads = true;
  }
  if (subs.some((item) => item.package === "deal-analyzer")) {
    status.dealAnalyzer = true;
  }

  return status;
};

/**
 *
 * @param {string} url URL to check
 * @returns a url with https:// if it doesn't have it
 */
const getValidUrl = (url) => {
  if (!url) {
    return "";
  }
  if (url.includes("://")) return url;
  else return "https://" + url;
};

/**
 *
 * @param {string} phoneNumberString number to return in the format +1 (123) 456-7890
 * @returns
 */
function formatPhoneNumber(phoneNumberString) {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    // var intlCode = match[1] ? '+1 ' : '';
    return ["(", match[2], ") ", match[3], "-", match[4]].join("");
  }
  return null;
}

function convertCurrencySystem(labelValue) {
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
        Math.abs(Number(labelValue)) >= 1.0e3
        ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
        : Math.abs(Number(labelValue));
}

function getAllDaysInMonth(year, month) {
  const today = new Date().getDate();
  const date = new Date(year, month, today);

  const dates = [];

  while (date.getMonth() === month) {
    dates.push(new Date(date).toDateString());
    date.setDate(date.getDate() + 1);
  }

  return dates;
}

function commaSeparate(x) {
  return x === 0 || x === "0"
    ? 0
    : x
      ? x
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          .trim()
      : "";
}
/**
 *
 * @param {*} string imageUrl Image url to be checked
 * @returns
 */
function checkImageLoad(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
}

/**
 *
 * @param {*} File uploaded file to be converted into base64
 * @returns
 */
const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Fetches coordinates for a given textual description using a Geocoding API.
 *
 * @param {string} directionText Vague directions or description.
 * @param {string} marketArea The name of the market area or neighborhood.
 * @param {string} apiKey Your Geocoding API key (e.g., for Google Maps).
 * @returns {Promise<object|null>} A promise that resolves to an object { lat: number, lng: number } or null if not found/error.
 */
async function getCoordinatesFromDescription(
  directionText,
  marketArea,
  apiKey,
  address,
) {
  // 1. Combine the inputs into a single query string. Add context like city/county.
  // Adding 'city, county' (your context) helps narrow down results.
  let query = "";
  if (directionText) query += `${directionText}, `;
  if (marketArea) query += `${marketArea}, `;
  if (address) query += `${address}`;

  const encodedQuery = encodeURIComponent(query);

  // 2. Construct the Google Maps Geocoding API URL
  const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedQuery}&key=${apiKey}`;

  // --- Optional: Bias results towards city, country ---
  // You can provide bounds or a location + radius to hint the API.
  // Approximate coordinates for city: 5.655, -0.184
  const biasedApiUrl = `${apiUrl}&radius=10000`; // Bias within 10km radius
  // Use 'apiUrl' or 'biasedApiUrl' in the fetch call below.
  // ---

  try {
    // 3. Make the HTTP request using fetch
    const response = await fetch(biasedApiUrl);

    // Check if the HTTP request itself was successful
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // 4. Parse the JSON response
    const data = await response.json();
    // console.log("API Response:", data); // For debugging

    // 5. Process the response and extract coordinates
    if (data.status === "OK" && data.results && data.results.length > 0) {
      // Success! Get coordinates from the first result
      const location = data.results[0].geometry.location; // This is usually { lat: number, lng: number }
      return location;
    } else if (data.status === "ZERO_RESULTS") {
      console.warn("Geocoding: No results found for the description.");
      return null;
    } else {
      // Handle other API statuses (OVER_QUERY_LIMIT, REQUEST_DENIED, etc.)
      console.error(
        `Geocoding API Error: ${data.status}`,
        data.error_message || "",
      );
      return null;
    }
  } catch (error) {
    console.error("Error during geocoding fetch:", error);
    return null;
  }
}

function calculateCenterFromCoordinates(coordinatesList = []) {
  let totalLatitude = 0;
  let totalLongitude = 0;
  let numberOfPoints = 0;

  if (coordinatesList.length === 0) {
    return null; // Or handle as appropriate for your application
  }

  for (let i = 0; i < coordinatesList.length; i++) {
    totalLatitude += Number(coordinatesList[i]?.lat);
    totalLongitude += Number(coordinatesList[i]?.lng);
    numberOfPoints++;
  }

  const centerLatitude = totalLatitude / numberOfPoints;
  const centerLongitude = totalLongitude / numberOfPoints;

  return {
    lat: centerLatitude,
    lng: centerLongitude,
  };
}

/**
 * Calculates the center of a shape defined by a 3D array of coordinates
 * (typically representing polygon rings).
 * This function averages the latitude and longitude of all vertex points found
 * within the nested arrays.
 *
 * @param {Array<Array<Array<number>>>} coordinates3D - A 3D array of coordinate pairs,
 * e.g., [[[lat1, lng1], [lat2, lng2], ...], [[latA, lngA], ...]].
 * @returns {{lat: number, lng: number} | null} An object with lat and lng for the center,
 * or null if no valid coordinates are found.
 */
function calculateCenterFrom3DCoordinates(coordinates3D = []) {
  if (!coordinates3D || coordinates3D.length === 0) {
    console.warn("Input 3D coordinates array is empty or null.");
    return null;
  }

  let totalLatitude = 0;
  let totalLongitude = 0;
  let numberOfPoints = 0;

  // Iterate through the outermost array (which contains rings)
  for (let i = 0; i < coordinates3D.length; i++) {
    const ring = coordinates3D[i];

    // Ensure the ring is an array
    if (Array.isArray(ring)) {
      // Iterate through the coordinates within the ring
      for (let j = 0; j < ring.length; j++) {
        const coord = ring[j];

        // Ensure the coordinate pair is valid [lat, lng]
        if (Array.isArray(coord)) {
          for (let k = 0; k < coord.length; k++) {
            const geo = coord[k];
            if (geo) {
              totalLatitude += geo?.lat; // Latitude
              totalLongitude += geo?.lng; // Longitude
              numberOfPoints++;
            }
          }
        } else {
          console.warn(`Invalid coordinate format found in ring ${i}:`, coord);
          // Optionally skip or handle invalid coordinates
        }
      }
    } else {
      console.warn(`Invalid ring format found at index ${i}:`, ring);
      // Optionally skip or handle invalid rings
    }
  }

  if (numberOfPoints === 0) {
    console.warn("No valid coordinate points found in the 3D array.");
    return null; // Return null if no valid points were processed
  }

  // Calculate the average
  const centerLatitude = totalLatitude / numberOfPoints;
  const centerLongitude = totalLongitude / numberOfPoints;

  return {
    lat: centerLatitude,
    lng: centerLongitude,
  };
}
/**
 * Checks if a URL string includes any of the words from a list.
 *
 * @param {string} url The URL string to check.
 * @param {string[]} words An array of words to look for.
 * @param {boolean} [caseSensitive=false] Whether the comparison should be case-sensitive. Defaults to false.
 * @returns {boolean} True if the URL includes at least one word from the list, false otherwise.
 */
function includesAnyWord(url, words, caseSensitive = false) {
  if (typeof url !== "string" || !Array.isArray(words)) {
    console.error(
      "Invalid input: URL must be a string and words must be an array.",
    );
    return false;
  }

  // If case-insensitive, convert the URL to lowercase once
  const searchUrl = caseSensitive ? url : url?.toLowerCase();

  // Use the .some() method to check if *any* word matches
  return words.some((word) => {
    if (typeof word !== "string") {
      console.warn("Skipping non-string item in word list:", word);
      return false; // Skip non-string items in the word list
    }
    const searchWord = caseSensitive ? word : word?.toLowerCase();
    return searchUrl?.includes(searchWord);
  });
}
/**
 * Attempts to extract the video ID from a given YouTube URL and returns
 * the standard embed URL format (https://www.youtube.com/embed/[VIDEO_ID]).
 * Handles watch URLs (e.g., https://www.youtube.com/watch?v=VIDEO_ID),
 * share URLs (e.g., https://youtu.be/VIDEO_ID), and potentially
 * existing embed URLs.
 *
 * Does NOT bypass YouTube's privacy or embedding restrictions.
 *
 * @param {string} youtubeUrl The full YouTube video URL.
 * @returns {string} The standard embed URL format or an empty string if the ID cannot be extracted.
 */
function getYouTubeEmbedUrlOrDef(youtubeUrl) {
  // Basic validation: ensure it's a non-empty string
  if (!youtubeUrl || typeof youtubeUrl !== "string") {
    return "";
  }

  try {
    const url = new URL(youtubeUrl);
    let videoId = "";

    // Check for standard YouTube hostnames
    if (url.hostname === "www.youtube.com" || url.hostname === "youtube.com") {
      // Handle watch pages like https://www.youtube.com/watch?v=VIDEO_ID
      if (url.pathname === "/watch") {
        videoId = url.searchParams.get("v");
      }
      // Handle embed URLs like https://www.youtube.com/embed/VIDEO_ID
      // (Although the goal is conversion TO embed, this handles cases where
      // the input might already be an embed URL and we just want the ID)
      else if (url.pathname.startsWith("/embed/")) {
        const pathSegments = url.pathname.split("/");
        if (pathSegments.length > 2) {
          videoId = pathSegments[2]; // Get the segment after /embed/
        }
      }
      // Add other specific youtube.com paths if needed (e.g., /v/...)
    }
    // Check for the youtu.be short URL hostname
    else if (url.hostname === "youtu.be") {
      // Handle https://youtu.be/VIDEO_ID
      const pathSegments = url.pathname.split("/");
      if (pathSegments.length > 1) {
        videoId = pathSegments[1]; // Get the segment after youtu.be/
      }
    }
    // Note: The 'googleusercontent.com/youtube.com' URLs you saw might be
    // internal or non-standard for public embedding. This function focuses
    // on standard public formats.

    // Validate the extracted videoId format (YouTube IDs are typically 11 characters)
    // This regex checks for 11 alphanumeric characters, hyphens, or underscores.
    if (videoId && /^[a-zA-Z0-9_-]{11}$/.test(videoId)) {
      // Return the standard HTTPS embed format
      return `https://www.youtube.com/embed/${videoId}`;
    } else {
      // If no valid video ID was found or format is wrong
      return youtubeUrl;
    }
  } catch (e) {
    // Handle cases where the input string is not a valid URL at all
    console.error("Could not parse URL:", youtubeUrl, e);
    return "";
  }
}

const fullName = (agent) => {
  if (!agent) return "";

  if (agent) {
    return `${agent?.first_name || agent?.firstName || ""} ${
      agent?.last_name || agent?.lastName || ""
    }`;
  }
};

function srcset(image, size, rows = 1, cols = 1) {
  return {
    src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
    srcSet: `${image}?w=${size * cols}&h=${
      size * rows
    }&fit=crop&auto=format&dpr=2x`,
  };
}

const cityFromAddress = (address) => {
  if (!address || typeof address !== "string") return "";
  const parts = address
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  // Prefer the second segment when present
  return parts.length >= 2 ? parts[1] : "";
};

const getCounties = (state) => {
  if (!state) return [];
  return Object.keys(countiesList[state]);
};
const getCities = (state, county) => {
  if (!state || !county) return [];
  return countiesList[state][county];
};
function getTimeAgoFromStartOfDay() {
  const now = new Date();
  const startOfDay = new Date();
  startOfDay.setHours(0, 0, 0, 0);
  const diffMs = now.getTime() - startOfDay.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diffMs / (1000 * 60)) % 60);

  if (diffHours < 1) {
    return `${diffMinutes} minutes ago`;
  }
  return `${diffHours} hours ago`;
}

function formatFullDateTime(dateString) {
  if (!dateString) return "—";
  return moment(dateString).format("MMMM D, YYYY [at] hh:mma");
}

function getSeoMeta(data, path, vendor) {
  const address = data?.address?.full || "";
  const city = data?.address?.city || "";
  const state = data?.address?.state || "";
  const subType = data?.property?.subType || "";
  const bedrooms = data?.property?.bedrooms || "";
  const bathsFull = data?.property?.bathsFull || "";
  const style = data?.property?.style || "";
  const typeDetails = [
    subType,
    bedrooms ? `${bedrooms}BR` : "",
    bathsFull ? `${bathsFull}BA` : "",
    style,
  ]
    .filter(Boolean)
    .join(" ");
  const features = [
    bedrooms ? `${bedrooms}BR` : "",
    bathsFull ? `${bathsFull}BA` : "",
  ]
    .filter(Boolean)
    .join(", ");

  let seoMetaTitle = "Property Details";
  let seoMetaDescription = `View property details for ${address}, ${city}, ${state}.`;

  if (data) {
    if (vendor === "off_market" || path.includes("off-market")) {
      const offMarketDetails = [
        bedrooms ? `${bedrooms}BR` : "",
        bathsFull ? `${bathsFull}BA` : "",
        style,
      ]
        .filter(Boolean)
        .join(" ");
      seoMetaTitle = `${
        offMarketDetails ? offMarketDetails + " " : ""
      }Off-Market Property at ${address}, ${city}`;
      seoMetaDescription = `This property at ${address}, ${city}, ${state} is currently off-market. See details, photos, and history.`;
    } else if (path.startsWith("/sold-homes")) {
      seoMetaTitle = `${
        typeDetails ? typeDetails + " " : ""
      }Sold Home at ${address}, ${city}`;
      seoMetaDescription = `Recently sold home at ${address}, ${city}, ${state}${
        features ? ", " + features : ""
      }. View sale price, features, and more.`;
    } else if (path.startsWith("/open-houses")) {
      seoMetaTitle = `${
        typeDetails ? typeDetails + " " : ""
      }Open House: ${address}, ${city}`;
      seoMetaDescription = `Attend an open house at ${address}, ${city}, ${state}${
        features ? ", " + features : ""
      }. See property details, photos, and schedule.`;
    } else if (path.startsWith("/rental")) {
      seoMetaTitle = `${
        typeDetails ? typeDetails + " " : ""
      }Home for Rent in ${city}`;
      seoMetaDescription = `Explore this rental property at ${address}, ${city}, ${state}${
        features ? ", " + features : ""
      }. See photos, price, and more.`;
    } else if (path.startsWith("/listing")) {
      seoMetaTitle = `${
        typeDetails ? typeDetails + " " : ""
      }Home for Sale in ${city}`;
      seoMetaDescription = `Explore this home for sale at ${address}, ${city}, ${state}${
        features ? ", " + features : ""
      }. See photos, price, and more.`;
    } else {
      seoMetaTitle = `${
        typeDetails ? typeDetails + " " : ""
      }Property at ${address}, ${city}`;
      seoMetaDescription = `View property details for ${address}, ${city}, ${state}${
        features ? ", " + features : ""
      }.`;
    }
  }

  return { seoMetaTitle, seoMetaDescription };
}

const getBoundary = async (city) => {
  const query = city?.split(" ").join("+").toLowerCase();
  const boundaries = [];

  try {
    const res = await axios.get(
      `https://nominatim.openstreetmap.org/search.php?city=${query}&countrycodes=us&polygon_geojson=1&format=jsonv2`,
    );
    const data = res?.data;

    // Define preferred address types in order of priority
    const preferredTypes = [
      "city",
      "city_district",
      "hamlet",
      "county",
      "town",
      "village",
      "suburb",
      "neighbourhood",
    ];

    // Find the first entry matching the preferred address types
    const matchedEntryList = data.filter(
      (entry) =>
        preferredTypes.includes(entry.addresstype) &&
        entry.geojson &&
        ["Polygon", "MultiPolygon"].includes(entry?.geojson?.type),
    );

    if (matchedEntryList && matchedEntryList?.length > 0) {
      matchedEntryList.forEach((boundary) => {
        let entryList = [];
        const geojson = boundary.geojson;

        if (geojson.type === "Polygon") {
          entryList = geojson.coordinates.map((ring) =>
            ring.map((coord) => ({ lat: coord[1], lng: coord[0] })),
          );
        } else if (geojson.type === "MultiPolygon") {
          entryList = geojson.coordinates.flatMap((polygon) =>
            polygon.map((ring) =>
              ring.map((coord) => ({ lat: coord[1], lng: coord[0] })),
            ),
          );
        }

        if (entryList?.length > 0) {
          const firstPoint = entryList[0][0];
          const lastPoint = entryList[0][entryList[0].length - 1];

          if (
            firstPoint?.lat !== lastPoint?.lat ||
            firstPoint?.lng !== lastPoint?.lng
          ) {
            entryList[0].push(firstPoint);
          }
        }

        boundaries.push(entryList);
      });
    }
  } catch (error) {
    console.error("Error setting boundaries:", error);
  }

  return boundaries;
};

// Helper function to check if a date string is today
const isToday = (dateString) => {
  const today = new Date();
  const selectedDate = new Date(dateString);
  return (
    today.getFullYear() === selectedDate.getFullYear() &&
    today.getMonth() === selectedDate.getMonth() &&
    today.getDate() === selectedDate.getDate()
  );
};

// Get disabled times based on selected date - only disable past times for today
const getDisabledTimesForDate = (selectedDate, timeData = []) => {
  // If the selected date is not today, all times are available
  if (!isToday(selectedDate)) {
    return [];
  }

  // For today, disable times that have already passed
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();
  const disabledList = [];

  timeData.forEach((time) => {
    const timeParts = time.split(" ");
    const [hours, minutes] = timeParts[0].split(":").map(Number);
    const isPM = timeParts[1] === "PM";

    let timeHour = hours;
    if (isPM && hours !== 12) timeHour += 12;
    if (!isPM && hours === 12) timeHour = 0;

    // If time is in the past, add to disabled list
    if (
      timeHour < currentHour ||
      (timeHour === currentHour && minutes < currentMinutes)
    ) {
      disabledList.push(time);
    }
  });

  return disabledList;
};

// get the next two weeks
function getNextTwoWeeks() {
  const today = new Date();
  const dates = [];
  for (let i = 0; i < 14; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push(date.toDateString());
  }
  return dates;
}

function highlightMatch(text = "", query = "") {
  const normalizedText = String(text);
  const normalizedQuery = String(query);
  if (!normalizedQuery) return normalizedText;

  const lowerText = normalizedText.toLowerCase();
  const lowerQuery = normalizedQuery.toLowerCase();
  const matchStart = lowerText.indexOf(lowerQuery);
  if (matchStart === -1) return normalizedText;

  const matchEnd = matchStart + lowerQuery.length;
  return (
    <>
      {normalizedText.slice(0, matchStart)}
      <span
        style={{
          backgroundColor: "rgba(66, 165, 245, 0.35)",
          fontWeight: 700,
        }}
      >
        {normalizedText.slice(matchStart, matchEnd)}
      </span>
      {normalizedText.slice(matchEnd)}
    </>
  );
}

export {
  scrollToTop,
  getDatesFromToday,
  removeUnderandCapitalize,
  formatNumber,
  getYoutubeEmbedLink,
  getSubscriptionStatus,
  getValidUrl,
  formatPhoneNumber,
  convertCurrencySystem,
  getAllDaysInMonth,
  commaSeparate,
  getOpenHouseDateFormat,
  getOpenHouseTime,
  crmlsOpenHouseTime,
  checkImageLoad,
  convertToBase64,
  getCoordinatesFromDescription,
  calculateCenterFromCoordinates,
  calculateCenterFrom3DCoordinates,
  includesAnyWord,
  getYouTubeEmbedUrlOrDef,
  fullName,
  srcset,
  cityFromAddress,
  getCounties,
  getCities,
  getNextTwoWeeks,
  getTimeAgoFromStartOfDay,
  formatFullDateTime,
  getSeoMeta,
  isToday,
  getDisabledTimesForDate,
  getBoundary,
  highlightMatch,
};
